
export default () => ({
    isLoading: false,
    listProduct: [],
    listFiscalFound: [],
    listRequisition: [],
    listSupplier: [],
    remissionExistent: [],
})